import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M94.7 135.3c1.4 1.5 3.3 2.2 5.3 2.2s3.9-.8 5.3-2.2l44.5-44.9c1.4-1.4 2.2-3.3 2.2-5.3s-.8-3.9-2.2-5.3c-1.4-1.4-3.3-2.2-5.3-2.2s-3.9.8-5.3 2.2l-31.9 32.1V17.5c0-4.1-3.3-7.5-7.4-7.5-4.1 0-7.4 3.4-7.4 7.5v94.4L60.7 79.8c-2.9-2.9-7.6-2.9-10.5 0-1.4 1.4-2.2 3.3-2.2 5.3s.8 3.9 2.2 5.3l44.5 44.9z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M181.9 115c-4.1 0-7.4 3.4-7.4 7.5v45c0 4.1-3.3 7.5-7.4 7.5H33c-4.1 0-7.4-3.4-7.4-7.5v-45c0-4.1-3.3-7.5-7.4-7.5-4.1 0-7.4 3.4-7.4 7.5v45c0 12.4 10 22.5 22.3 22.5h134c12.3 0 22.3-10.1 22.3-22.5v-45c-.1-4.2-3.4-7.5-7.5-7.5z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}